import React from "react";
import { RackType } from "../../interfaces/RackType";
import { useAuth } from "../../hooks/auth";
import { useTranslation } from 'react-i18next';
import RackTypeApi from "../../services/RackTypeApi";
import Select from "./Select";

type ComboProps = any;

const SelectRackType: React.FC<ComboProps> = ({ name, control, multiple, defaultValue, style, serviceType, label, ...restProps}) => {
  const { user } = useAuth();
  const { t: _t } = useTranslation("General");
   

  const handleSearchPackingFcm = async(val: any) => {
    let filter = {IdEmpresa: user.company.companyID}
    return await RackTypeApi.search(val)
    .then(result => {
      let rack = result.items.map((rackType: RackType) => {
        return {
              label: rackType.code + " - " + rackType.description, 
              code: rackType.code,
              rackTypeId: rackType.id,
              rackTypeCode: rackType.code,
              rackTypeDescription: rackType.description,
              ownerSupplierId: rackType.ownersupplierId
          };
        });

        return rack;
      })
  }

  return (
    <Select 
      {...restProps}
      allowSelectValueNotFound={false}
      label={label ? label : _t("PackingFcm")} 
      name={name}
      control={control} 
      options={[]}
      style={style}
      searchFunction={handleSearchPackingFcm}
      defaultValue={defaultValue}
      multiple={multiple} />
  )
}

export default SelectRackType;
